import { render, staticRenderFns } from "./TabGeneralInfo.vue?vue&type=template&id=9b77dce4&scoped=true&"
import script from "./TabGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./TabGeneralInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b77dce4",
  null
  
)

export default component.exports